import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { Drillstring2Model } from '../components/drillstring2/drillstring2.model';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

@Injectable({
  providedIn: 'root'
})
export class Drillstring2Service {
  private drillstringCache$: Observable<Drillstring2Model> | null = null;

  constructor(private http: HttpClient) { }

  public getDrillstringForTubular(): Observable<Drillstring2Model> {
    if (!this.drillstringCache$) {
      this.drillstringCache$ = this.http
        .get<Drillstring2Model>(`${PeriforApiEndpoint}/drillstring2`)
        .pipe(
          map(data => new Drillstring2Model(data)),
          catchError(() => of(null as Drillstring2Model)),
          shareReplay(1)
        );
    }
    setTimeout(() => this.drillstringCache$ = null, 1000);
    return this.drillstringCache$;
  }

  public updateDrillstringForTubular(model: Drillstring2Model): Observable<boolean> {
    return this.http.put<boolean>(`${PeriforApiEndpoint}/drillstring2`, model);
  }

  public setDrillstring(model: Drillstring2Model): Observable<Drillstring2Model> {
    return this.http.post<Drillstring2Model>(`${PeriforApiEndpoint}/drillstring2`, model);
  }
}
